import { Button } from '@/components/ui/button';

import { useTheme } from '../../../../hooks/useTheme';
import { useCallback } from 'react';
import { IconBrightness } from '@tabler/icons-react';

export function ModeToggle() {
  const { setThemeModel, themeModel } = useTheme();
  const toggleTheme = useCallback(() => {
    setThemeModel(themeModel === 'dark' ? 'light' : 'dark');
  }, [themeModel, setThemeModel]);
  return (
    <Button variant="secondary" size="icon" className="group/toggle size-8" onClick={toggleTheme}>
      <IconBrightness />
      <span className="sr-only">切换主题</span>
    </Button>
  );
}
